module.exports = __webpack_public_path__ + "img/WebApp.db612c94.svg";